import { render, staticRenderFns } from "./screensDetails.vue?vue&type=template&id=db80fd00&scoped=true&lang=pug"
import script from "./screensDetails.vue?vue&type=script&lang=js"
export * from "./screensDetails.vue?vue&type=script&lang=js"
import style0 from "./screensDetails.vue?vue&type=style&index=0&id=db80fd00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db80fd00",
  null
  
)

export default component.exports